import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import r2wc from '@r2wc/react-to-web-component';
import { resetAllState } from './utils/resetAllState';
import { startBroadcasting, startReceiving } from './services/authBridge';

// Emergency reset trigger — checked BEFORE the React tree mounts so a
// wedged session can be recovered even when the UI itself is broken.
// Visit any embed URL with `?muuzbox-nuke=1` (e.g. shared via SMS to a
// stuck phone) and the full nuke routine runs, then reloads. Also
// exposes window.muuzboxNuke() for DevTools / parent postMessage.
try {
  const params = new URLSearchParams(window.location.search || '');
  if (params.get('muuzbox-nuke') === '1') {
    // Fire and forget — resetAllState handles its own reload at the end.
    resetAllState();
  }
  // Soft variant for the post-deploy loop: ?muuzbox-fresh=1 clears service
  // workers + Cache Storage so the new bundle loads, but KEEPS the login
  // (unlike the nuke). See utils/freshReload.js.
  if (params.get('muuzbox-fresh') === '1') {
    import('./utils/freshReload').then((m) => m.freshReload()).catch(() => {});
  }
} catch (_) {}

// Listen for the kill-switch service worker's "purge complete, reload"
// message. When the temporary kill switch SW activates it nukes every
// Cache Storage entry and tells every open client to reload — at which
// point the page must actually call location.reload to pull fresh HTML
// and JS from the network (the SW has no fetch handler, so there's
// nothing intercepting it now). Without this listener, users with the
// app already open would still see the cached buggy bundle until they
// manually closed and reopened the tab.
try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event && event.data && event.data.type === 'muuzbox-killswitch-reload') {
        console.warn('[muuzbox] kill switch SW signalled reload — fetching fresh bundle');
        try { window.location.reload(); } catch (_) {}
      }
    });
  }
} catch (_) {}

// Cross-origin auth bridge — installs the receiver AND broadcaster so
// this PWA works correctly whether it's the parent (opening iframes
// itself) or the child (loaded inside another Muuzbox surface's iframe).
// Idempotent — safe if this file is loaded multiple times. See
// services/authBridge.js for the full design + trust model.
try {
  startReceiving();
  startBroadcasting();
} catch (e) {
  console.warn('[muuzbox] authBridge init failed:', e && e.message);
}

const wcMuuzbox = r2wc(App, { props: { items: "json", funcProp: "function", } });

customElements.define("r2w-wcmuuzbox", wcMuuzbox);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();